import { render, staticRenderFns } from "./Registry.vue?vue&type=template&id=dbb2acee"
import script from "./Registry.vue?vue&type=script&lang=js"
export * from "./Registry.vue?vue&type=script&lang=js"
import style0 from "./Registry.vue?vue&type=style&index=0&id=dbb2acee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports